<template>
  <div class="props-flow">
    <div class="nav">
      <div class="top">
        <van-sticky>
          <NavBar
            ref="navBar"
            :showBack="false"
            title="二重螺旋【狩夜测试】资格查询"
          ></NavBar>
        </van-sticky>
      </div>
    </div>
    <div class="form-content">
      <van-form @submit="onSubmit">
        <van-field
          v-model="form.order_id"
          type="tel"
          name="order_id"
          label="手机号"
          placeholder="请输入手机号"
          :rules="[
            { required: true, message: '' },
            { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号' },
          ]"
        />
        <div style="margin: 16px;">
          <van-button
            class="submit-btn"
            :loading="confirmLoading"
            block
            type="primary"
            size="large"
            native-type="submit"
          >
            查询
          </van-button>
        </div>
      </van-form>
    </div>
    <modal
      v-if="isShowModal"
      :data="currentData"
      @close="isShowModal = false"
    />
  </div>
</template>
<script>
import Modal from "./modal.vue";
import { apiGetRedEnvelope } from "@/api/common";

export default {
  components: {
    Modal,
  },
  data() {
    return {
      confirmLoading: false,
      isShowModal: false,
      form: {
        order_id: "",
      },
      currentData: "",
      staticConfig: {},
    };
  },
  mounted() {
    // 修改导航栏标题
    document.title = "狩夜测试资格查询";
    window.staticFn.customEvent("visit_redeem_query", {
      game_id: 2277,
    });

    const staticConfig = window.staticFn && window.staticFn.getConfig();
    this.staticConfig = staticConfig || {};
  },
  beforeDestroy() {
    // 修改导航栏标题
    document.title = "customer";
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    onSubmit() {
      this.confirmLoading = true;
      const params = {
        game_id: 2277,
        guest_id: this.staticConfig.guest_uid,
        order_number: this.form.order_id,
      };
      apiGetRedEnvelope(params)
        .then((res) => {
          if (res.code === 0 && res.data) {
            this.currentData = 1;
            this.isShowModal = true;
          } else if (res.code === -1) {
            this.currentData = -1;
            this.isShowModal = true;
          }
        })
        .finally(() => {
          this.confirmLoading = false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
.props-flow {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: auto;
  .nav {
    flex: 0 0 auto;
    .choose-line {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 44px;
      padding: 0 10px;
      box-sizing: border-box;
      border-bottom: 1px solid #f7f7f7;
      background-color: #fff;
      .label {
        color: #242424;
        font-size: 15px;
      }
    }
    .history {
      display: flex;
      align-items: center;
      i {
        font-size: 20px;
      }
    }
  }
}
/deep/ .van-search {
  padding: 0;
}
/deep/ .van-row {
  color: #646566;
  background-color: #fff;
  &.header {
    color: #000;
    font-size: 14px;
  }
  .van-col {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px 4px;
    border-bottom: 1px solid #ebedf0;
  }
}
</style>
